"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVariantFirstDate = void 0;
const dayjs = require("dayjs");
const getOrderLineDate_1 = require("./getOrderLineDate");
const getVariantFirstDate = (variant) => {
    if (!variant || !variant.order_lines || variant.order_lines.length === 0) {
        return dayjs().format("YYYY-MM-DD");
    }
    const dates = [];
    variant.order_lines.forEach((line) => {
        const orderLineDate = (0, getOrderLineDate_1.getOrderLineDate)(line);
        if (!orderLineDate)
            return;
        dates.push(dayjs(orderLineDate, "DD-MM-YYYY"));
    });
    if (dates.length === 0) {
        return dayjs().format("YYYY-MM-DD");
    }
    const firstDate = dates.reduce((a, b) => (a.isBefore(b) ? a : b));
    return firstDate.format("YYYY-MM-DD");
};
exports.getVariantFirstDate = getVariantFirstDate;
